import React from "react";
import { makeStyles, Typography } from "@material-ui/core/";

const useStyle = makeStyles((theme) => ({
  formContainer: {
    padding: "0.9rem 0.7rem",
    margin: "0",
    background: "#005598",
    display: "flex",
    alignItems: "center",
    color: "#fff",
  },
  formContainerHeader: {
    padding: "0 0.7rem",
    fontSize: "1rem",
    margin: "0",
    display: "flex",
    alignItems: "center",
  },
}));

function Header(props) {
  const classes = useStyle(props);

  return (
    <>
      <Typography component="div" className={classes.formContainer}>
        {props.name}
      </Typography>
      {props.header && (
        <Typography component="div" className={classes.formContainerHeader}>
          <b>{props.header}</b>
        </Typography>
      )
      }
    </>

  );
}

export default Header;
